export default __webpack_public_path__ + "static/media/facebookLogo.6b4487e0.svg";